module.exports = __webpack_public_path__ + "static/media/kempy_akce.cc51f658.jpg";